import RSVP2 from './RSVP2'
export default RSVP2
